export default __webpack_public_path__ + "static/media/tell_company.0239a64b.svg";